export const getUrlLogin = () => {
    // hàm xử lý khi chưa đăng nhập
    // xóa full token
    document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    axios.defaults.headers.common['Authorization'] = null;

    if(window.location.pathname.slice(0, 6) != process.env.VUE_APP_BASE_URL + 'login'){
        let href = location.href;
        window.location.href = process.env.VUE_APP_BASE_URL +  'login?redirect=' + btoa(href);
    }
}


export const formatNumberPhone = (phone) => {
    if(typeof phone == "undefined") return '';
    phone = phone.toString();
    if(phone.substr(0, 2) == '+84'){
        phone = '0' + phone.substr(3);
    }
    phone = phone.replace(/[^0-9]/g, '');
    if(phone.length != 10){
        return phone;
    }
    return phone.substr(0, 4) + ' ' + phone.substr(4, 3) + ' ' + phone.substr(7, 3);
}

export const getPhoneNumber = (phone) => {
    if(typeof phone == "undefined") return '';
    phone = phone.toString();
    if(phone.substr(0, 2) == '+84'){
        phone = '0' + phone.substr(3);
    }
    phone = phone.replace(/[^0-9]/g, '');
    return phone;
}

export const btoaRefactor = (val) => {
    val = btoa(encodeURIComponent(val))
    return val
}

export function formatNumber(number) {
    number = number.toString().replace(/\./g, '');
    number = number.replace(/[^0-9]/g, '');
    number = number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return number;
}


export const stringToNumber = (number) => {
    number = number.toString().replace(/\./g, '');
    number = number.replace(/[^0-9]/g, '');
    if(number === '') number = 0;
    number = parseInt(number);
    return number;
}
